import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getPotentialBurnData, resetField } from "../../../store/actions";
import FlameRating from "../../../sharedComponents/flameRating";
import PaginatedTable from "../../../sharedComponents/tableWithPagination";

const PotentialBurn = ({ exercise, exercisesPotentialBurnData, getPotentialBurnData }) => {
	useEffect(() => {
		exercise && exercise.id && getPotentialBurnData(exercise.id);
	}, [exercise, getPotentialBurnData]);

	useEffect(() => {
		return () => resetField("Exercises.exercisesPotentialBurnData", {});
	});

	const columns = [
		{
			Header: "Minutes",
			accessor: "Minutes",
			sortable: false,
			className: "text-center",
			headerClassName: "text-center",
			width: 90
		},
		{
			Header: "Est. Calories",
			accessor: "Minutes",
			sortable: false,
			Cell: ({ original }) => <span>{original["Est. Calories"]}</span>,
			className: "text-center",
			headerClassName: "text-center"
		}
	];

	return exercisesPotentialBurnData ? (
		<div className="block block-primary p-4 mb-4">
			<h4 className="text-primary-dark mt-2">Potential Burn</h4>
			<div className="d-flex align-items-center">
				<FlameRating className="mr-2" value={exercisesPotentialBurnData.value} />
				<div className="small">{exercisesPotentialBurnData.name}</div>
			</div>
			<PaginatedTable data={exercisesPotentialBurnData.met_table} columns={columns} className="table-default table-sm" />
			<p className="bold">{exercisesPotentialBurnData.message}</p>
			<p>
				This is a mathematical estimate based on Metabolic Equivalent of Task (MET) values. The actual calories used by
				your body may vary.
			</p>
			<p>Used with permission:</p>
			<p>
				Ainsworth BE.
				<br /> (2002, January)
			</p>
			<a href="http://prevention.sph.sc.edu/tools/compendium.htm" rel="noopener noreferrer" target="_blank">
				<p>The Compendium of Physical Activities</p>
			</a>
			<a
				href="http://prevention.sph.sc.edu/tools/docs/documents_compendium.pdf"
				rel="noopener noreferrer"
				target="_blank">
				<p className="m-0">Tracking Guide</p>
			</a>
		</div>
	) : null;
};

const mapStateToProps = (state) => {
	return {
		exercisesPotentialBurnData: get(state, "Exercises.exercisesPotentialBurnData", {})
	};
};

const mapDispatchToProps = {
	getPotentialBurnData,
	resetField
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(PotentialBurn);
